import { render, staticRenderFns } from "./AcademicPositionsGrid.vue?vue&type=template&id=cc66eee0"
import script from "./AcademicPositionsGrid.vue?vue&type=script&lang=js"
export * from "./AcademicPositionsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports